import type { GlobalToken } from "antd/es/theme/interface";

/**
 * Color utility functions for theme-aware styling
 */

/**
 * Converts a hex color to rgba format
 * @param hex - Hex color string (e.g., "#f37233")
 * @param alpha - Alpha value between 0 and 1
 * @returns rgba color string
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  const normalized = hex.trim();
  if (!normalized.startsWith("#") || normalized.length < 7) {
    return normalized;
  }
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/** Distinct chart / list series colors derived from the active Ant Design token set */
export const getChartSeriesColors = (token: GlobalToken): string[] => [
  token.colorPrimary,
  token.colorSuccess,
  token.colorInfo,
  token.colorWarning,
  token.colorError,
  token.colorPrimaryActive,
];
